import { all, takeEvery, put, call } from 'redux-saga/effects'
import { notification } from 'antd'
import actions from './actions'
import { SAVE_200_MSG, SAVE_200_DESC, DEL_200_MSG, DEL_200_DESC } from '../../constants'
import { list, find, save, remove } from '../../services/invoice2Item'

function* fetchInvoice2Items({ size, index, searchTerm, orderBy, invoiceID }) {
  size = size || localStorage.getItem('pageSize') || 150

  const savedFilters = localStorage.getItem('invoice2ItemFilters')

  if (savedFilters) {
    const parsedFilters = JSON.parse(savedFilters)

    invoiceID = invoiceID || parsedFilters.invoiceID || null
  }

  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, size, index, searchTerm, orderBy, invoiceID)
  yield put({
    type: actions.LIST_INVOICE2ITEM,
    result,
  })
}

function* fetchInvoice2ItemEdit({ id }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(find, id)
  yield put({
    type: actions.EDIT_INVOICE2ITEM,
    result,
  })
}

function* fetchInvoice2ItemSave(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(save, values)
  if (result !== null) {
    notification.success({ message: SAVE_200_MSG, description: SAVE_200_DESC })
  }
  yield put({
    type: actions.SAVE_INVOICE2ITEM_RECIEVED,
    result,
  })
}

function* fetchInvoice2ItemDelete({ id }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(remove, id)
  console.log('result in saga', result)
  if (result !== null) {
    notification.success({ message: DEL_200_MSG, description: DEL_200_DESC })
  }
  yield put({
    type: actions.DELETE_INVOICE2ITEM_RECIEVED,
    result,
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FETCH_INVOICE2ITEMS, fetchInvoice2Items),
    takeEvery(actions.FETCH_INVOICE2ITEM, fetchInvoice2ItemEdit),
    takeEvery(actions.SAVE_INVOICE2ITEM, fetchInvoice2ItemSave),
    takeEvery(actions.DELETE_INVOICE2ITEM, fetchInvoice2ItemDelete),
  ])
}
